import { decode } from 'html-entities'

export const EN_DASH = decode('&ndash;')
export const EM_DASH = decode(`&mdash;`)
